import styled from 'styled-components';
import { H2 } from '../../theme/layout';


export const Title = styled(H2)`
  text-transform: uppercase;
`;
